import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InvoiceCollectionNotesBus extends BaseBus
{
    constructor(busObj: InvoiceCollectionNotesBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.invoiceCollectionNoteId;
    }
    setId(id: any) {
        this.invoiceCollectionNoteId = id;
    }
    setParentId(id: any) {
        this.invoiceId = id;
    }
    initialize(data: InvoiceCollectionNotesBus) {
        super.initialize(data);
        try {
           this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setFromForm(data: InvoiceCollectionNotesBus) {
        super.setFromForm(data);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
        if (!CommonFunctions.hasGuidValue(this.personId)) {
            this.personId = personId;
        }
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.personId = personId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    invoiceCollectionNoteId: any;
    invoiceId: any;
    collectionNoteCodeId: any;
    personId: any;
    note: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    personName: string;
    collectionNoteCode: string;
}
